import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteCheckoutExperience = {
  name: "deleteCheckoutExperience" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.void(),
};
